import {Backdrop, Box, Button, CircularProgress, Dialog, MenuItem, Stack, TextField, Typography} from '@mui/material'
import CalculateIcon from '@mui/icons-material/Calculate';
import Header from '../Components/layout/Header';
import { useEffect, useState, useContext } from 'react';
import { Context } from "../App";
import { API } from "../conf";
import Alerte from '../Components/ui/alerte';
import NotifInfo from '../Components/ui/notif-info';
import ServicesButton from '../Components/ui/ServicesButton';
import Exercice from '../Components/ui/exerciceSelect';

function Home() {
  const { updateConnect, eglise,setEglise, exercice } = useContext(Context)
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [loading, setLoad] = useState(true)
  const [eglises, setEglises] = useState([])
  const [egliseId, setEgliseId] = useState('')
  const [can_verse, setVers] = useState(0)
  const have_rapport = true
  const [eglise_solde, setSolde] = useState()
  const [petite_caisse, setPC] = useState()
  const [msg, setMsg] = useState('')
  const [alerts, setAlerts] = useState([])
  const [dismissedNums, setDismissedNums] = useState(null)

  useEffect(()=>{
    if(!user) {
      updateConnect(false)
    }
  },[])

  useEffect(()=>{
    async function get_eglises() {
      const query = new URLSearchParams({annee: exercice}).toString()
      fetch(API.concat(`/eglises/exercice?${query}`), {
        method:'POST',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body: JSON.stringify(user.eglises?.length>0 ? 
          {number:{$in: user.eglises}} : 
          user.level>=4 ? {type: {$in: ['église', 'fédération']}} : {type:'église'}
        )
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const json = await response.json()
            setEglises(json.filter(item=>item.type==='église'))
            setLoad(false)
          }
        }
      })
    }
    if(!user) return
    if (user?.level>2||(user.eglises.length>0&&eglises.length!==user.eglises.length&&eglises.slice().sort().join()!==user.eglises.slice().sort().join())) {
      get_eglises()      
    } else {
      setLoad(false)
    }
  },[exercice])

  useEffect(()=>{
    function check_possible_action() {
      fetch(API.concat(`/dons/simple/by/${JSON.stringify({eglise: eglise?.number, exercice, $or: [{is_preverse: false}, {is_cloture: true}]})}`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const dons = await response.json()
            setVers(dons.filter(don => !don.is_preverse).length)
          }
        }
      })
    }

    function get_eglise_solde() {
      const query = new URLSearchParams({eglise: eglise?.number, exercice}).toString()
      fetch(API.concat(`/comptes/by?${query}`), {
        method:'GET',
        headers:{
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }
      }).then(async(response) => {
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const comptes = await response.json()
            setSolde(comptes.find(cpt=> cpt.type==='liaison')?.solde??0);
            setPC(comptes.find(cpt=> cpt.type==='petite-caisse'));
            if (eglise&&eglise.type==='église'&&comptes.reduce((tt,cpt)=>tt+cpt.percent,0)<100) {
              setMsg('Attention! Répartition du budget incomplète.')
            // } else if(eglise&&eglise.type==='église'&&comptes.filter(cpt=>!['petite-caisse', 'liaison'].includes(cpt.type)).reduce((tt,cpt)=>tt+cpt.solde,0)!==comptes.find(cpt=>cpt.type==='liaison').solde) {
            //   setMsg('Attention! Solde compte principal différent du solde total des comptes.')
            } else setMsg('')
            setLoad(false)
          }
        }
      })
    }

    function getAlerts() {
      const headers = { Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionStorage.getItem('token') }
      fetch(API.concat(`/alerts/active?${new URLSearchParams({eglise: eglise.number, exercice}).toString()}`), { method:'GET', headers })
        .then(async(response) => {
          const token = response.headers.get('x-auth-token')
          if(response.status === 401) { sessionStorage.clear(); updateConnect(false) }
          else {
            if (token && token !== sessionStorage.getItem('token') && token !== '') sessionStorage.setItem('token', token)
            if (response.status === 200) setAlerts(await response.json())
          }
        })
      fetch(API.concat('/alerts/dismissed'), { method:'GET', headers })
        .then(async res => { if (res.status === 200) setDismissedNums(await res.json()) })
    }

    if (eglise!==''&&eglise.number) {
      get_eglise_solde()
      getAlerts()
      if(eglise.type==='église')check_possible_action()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eglise, exercice])

  useEffect(()=>{
    if (egliseId!=='') {
      setEglise(eglises.find(el=>el._id===egliseId)??egliseId)      
    }
  },[egliseId])

  useEffect(()=>{
    if(eglises.some(el=>el._id===eglise._id)) {
      setEgliseId(eglise._id)
    }
  },[eglises])

  if (!user?.access) return <div></div>
  return (
    <div style={{display:'flex', flexDirection:'column', height:'100vh'}}>
      <Header/>
      <Box display='flex'>
        <Box display='flex' flex={1} rowGap={1} flexDirection='column' sx={{alignItems:'start', padding:'15px'}}>
          <Exercice/>
          {exercice&&dismissedNums!==null&&alerts.filter(a=>a.level===1&&!dismissedNums.includes(a.num)).map(alert=>(
            <NotifInfo key={alert._id} alert={alert} onDismiss={num=>setDismissedNums(old=>[...old, num])}/>
          ))}
          {exercice&&alerts.filter(a=>a.level>=2).sort((a, b)=>b.level-a.level).map(alert => (
            <Alerte key={alert._id} alert={alert} />
          ))}
        </Box>
        <Box display='flex' flex={1} flexDirection='column' sx={{alignItems:'end'}} >
          <Box display='flex' flexDirection='row' justifyContent='end' alignItems='start' padding='15px'>
            {eglise!==''&&eglise!=='indifferent'&& !loading&&<Box sx={{ backgroundColor:'verdigris.main', padding:'20px', borderRadius:5}} >
              <Typography variant='h4' textAlign='center'>Solde: {eglise_solde?.toFixed(2)} €</Typography>
              <Typography variant='h5' textAlign='center'>Petite-Caisse: {petite_caisse?.solde?.toFixed(2)} €</Typography>
              <Typography variant='h5' textAlign='center' >Dons à verser: {can_verse}</Typography>
            </Box>}
          </Box>
          {user.access.includes("/comptes/consultation")&&eglise!==''&&<Button variant='outlined' sx={{ alignSelf:'end', marginRight:'15px'}} href='/comptes/consultation'>Consulter Comptes</Button>}
          {/* <Button variant='outlined' sx={{ alignSelf:'end', marginRight:'15px', marginTop:'15px'}} href='/comptes/consultation'>Synchroniser</Button> */}
        </Box>
      </Box>
      {(user.eglises.length>1||user.level>2)&& exercice&&<Box display='flex' flex={1} flexDirection='column' alignItems='center' mt={0.5} mb={2}>
        <Typography variant='h5' marginBottom='15px'>Choisissez une église</Typography>
        <TextField select required sx={{width:'35%', minWidth:'300px'}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
          <MenuItem value='indifferent'>Indifférent</MenuItem>
          {eglises.sort((a,b)=>(a.nom+' '+a.commune)<(b.nom+' '+b.commune)?-1:1).map(item=><MenuItem key={item._id} value={item._id} style={{textTransform:'capitalize'}}>{item.nom} - {item.commune}</MenuItem>)}
        </TextField>
      </Box>}

      <Stack direction='column' spacing={5} sx={{alignSelf:'center', display:'flex', justifyContent:'center', paddingBottom:'50px'}}>
        {eglise!==''&&exercice&&<Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes("/recettes/enregistrement-des-fonds")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/recettes/enregistrement-des-fonds">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Recettes</Typography>
          </Button>}
          {user.access.includes("/caisse")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/caisse">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>caisse</Typography>
          </Button>}
          {user.access.includes("/versements/enregistrement")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/versements/enregistrement">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Versements</Typography>
          </Button>}
          {user.access.includes('/depenses/enregistrement')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/depenses/enregistrement">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Dépenses</Typography>
          </Button>}
          {user.access.includes('/depenses/courantes')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/depenses/courantes">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} textAlign='center' position={"bottom"}>Dépenses courantes</Typography>
          </Button>}
          {user.access.includes('/depenses/abonnements')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/depenses/abonnements">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} textAlign='center' position={"bottom"}>Abonnements</Typography>
          </Button>}
          {user.access.includes("/caisse/versements")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/caisse/versements">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign='center'>Versements Caisse</Typography>
          </Button>}
          {user.access.includes("/versements/banque")&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href="/versements/banque">
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign='center'>Versements Banque</Typography>
          </Button>}
        </Stack>}

        {eglise!==''&& exercice&&<Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes('/cloture')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/cloture'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Clôture</Typography>
          </Button>}
          {user.access.includes('/rapports')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} disabled={!have_rapport} href='/rapports'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Rapport</Typography>
          </Button>}
          {user.access.includes('/rapports')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/rapports/annuel'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} textAlign="center">Rapport annuel</Typography>
          </Button>}
        </Stack>}

        {eglise!==''&&exercice&&<Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}> 
          {user.access.includes('/journal/dons')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/dons'>
            <CalculateIcon fontSize='large'/>
            <Typography textAlign='center' fontSize={12} position={"bottom"}>Journal des recettes</Typography>
          </Button>}
          {user.access.includes('/journal/dons')&&eglise!==''&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/dons-inter-eglise'>
            <CalculateIcon fontSize='large'/>
            <Typography textAlign='center' fontSize={12} position={"bottom"}>Dons inter-église</Typography>
          </Button>}
          {user.access.includes('/journal/versements')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/versements'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign='center'>Journal des versements</Typography>
          </Button>}
          {user.access.includes('/journal/depenses')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/depenses'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} align='center'>Journal des dépenses</Typography>
          </Button>}
          {user.access.includes('/journal/petite-caisse')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/petite-caisse'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} align='center' position={"bottom"}>Journal de petite caisse</Typography>
          </Button>}
          {user.access.includes('/journal/virements')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/virements'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} align='center' position={"bottom"}>Journal des virements</Typography>
          </Button>}
          {user.access.includes('/journal/global')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/journal/global'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"} textAlign={'center'}>Journal global</Typography>
          </Button>}
          {user.access.includes('/web&bornes')&&<Button variant='contained' disabled style={{width:100, height:100, flexDirection:'column'}}>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Dons web/bornes</Typography>
          </Button>}
        </Stack>}
        
        {msg!==''&&<Typography variant='subtitle1' color='carmine.main' align='center' marginTop={1}>{msg}</Typography>}
        <Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes('/donateurs')&&eglise!==''&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/donateurs'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Donateurs</Typography>
          </Button>}
          {user.access.includes('/cerfa')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/cerfa'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>CERFA</Typography>
          </Button>}
          {user.access.includes('/comptes')&&eglise!==''&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/comptes'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Comptes</Typography>
          </Button>}
          {user.access.includes('/fournisseurs')&&eglise!==''&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/fournisseurs'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Fournisseurs</Typography>
          </Button>}
          {user.access.includes('/users')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/users'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Utilisateurs</Typography>
          </Button>}
          {user.access.includes('/eglises')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/eglises'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Églises</Typography>
          </Button>}
          {user.access.includes('/regions')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/regions'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Régions</Typography>
          </Button>}
        </Stack>
        
        {['/export/ebp','/dada-base', '/alertes', '/logs'].some(ac=>user.access.includes(ac))&&
        <Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {user.access.includes('/alertes')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/alertes'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>Alertes</Typography>
          </Button>}
          {user.access.includes('/logs')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/logs'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} align='center' position={"bottom"}>Journaux logs</Typography>
          </Button>}
          {user.access.includes('/export/ebp')&&exercice&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/export/ebp'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} align='center' position={"bottom"}>export EBP</Typography>
          </Button>}
          {user.access.includes('/dada-base')&&<Button variant='contained' style={{width:100, height:100, flexDirection:'column'}} href='/dada-base'>
            <CalculateIcon fontSize='large'/>
            <Typography fontSize={12} position={"bottom"}>DB</Typography>
          </Button>}
        </Stack>}
        {/* {["/esdras/commandes", "/esdras/billets", "/esdras/projects"].some(ac=>user.access.includes(ac))&&
        <Stack direction='row' spacing={2} sx={{borderBottom:1, paddingBottom:'5px', paddingX:'10px'}}>
          {[{label:'Gestion des commandes Esdras', button_title:'Commandes', ref:"/esdras/commandes"},
            {label:'Gestion des billets emis', button_title:'Billets', ref:"/esdras/billets"},
            {label: 'Gestion des projet et évènements', button_title:'Évènements et Projets', ref:"/esdras/projects"},]
            .filter(item=>user.access.includes(item.ref)).map((item, index) => (
              <ServicesButton key={index} {...{ label: item.button_title, icon: <CalculateIcon fontSize='large'/>, href: item.ref }}/>
            ))}
        </Stack>} */}

      </Stack>
      
      {/* <Dialog open={open} onClose={()=>setOpen(false)} maxWidth='xs' >
        <Typography variant='subtitle1' align='center' margin='15px'>Clôturer l'année {year} et créer et ouvrir l'année {next_year}</Typography>
        <Stack direction='row' spacing={2} alignSelf='end' margin='15px'>
          <Button onClick={()=>setOpen(false)}>non</Button>
          <Button variant='contained'>oui</Button>
        </Stack>
      </Dialog> */}

      <Backdrop open={loading}><CircularProgress/></Backdrop>
    </div>
  );
}

export default Home;
